import { createFileRoute } from '@tanstack/react-router';
import { ServiceTypesPage } from '@/pages/settings/ServiceTypesPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

export const Route = createFileRoute('/_authenticated/_app/chain/master-catalog')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['companySettings.manageServiceTypes'], redirectTo: '/dashboard' }),
	component: ServiceTypesPage,
});
